import React, { Component } from "react";
import { connect } from "react-redux";
import { cscqSubmit, cscqSelectOption } from "@learningblocks/exp-redux";

import { injectIntl, FormattedMessage } from "react-intl";

import "./styles.scss";

class PredictionsChoiceQuestion extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleRadioChange = (e) => {
    this.props.cscqSelectOption({
      componentID: this.props.id,
      optionID: Number(e.target.value),
    });
  };

  handleRadioChangeKey = (e) => {
    this.props.cscqSelectOption({
      componentID: this.props.id,
      optionID: Number(e.target.previousSibling.value),
    });
  };

  validatePSCQ = () => {
    this.props.cscqSubmit(this.props.id);
  };

  render() {
    const questionIndex = this.props.index;

    return (
      <div className="predictionsChoiceQuestion">
        <div className="predictionsChoiceQuestion-inner-wrap">
          <h4 className="label">
            {this.props.index +
              ". " +
              this.props.intl.formatMessage({
                id: this.props.label,
                defaultMessage: this.props.label,
                description: "",
              })}
          </h4>
          <p
            dangerouslySetInnerHTML={{
              __html: this.props.text
                ? this.props.intl.formatMessage({
                    id: this.props.text,
                    defaultMessage: this.props.text,
                    description: "",
                  })
                : "",
            }}
            style={{ fontSize: "16px", fontWeight: "400" }}
          ></p>
          {this.props.options.map((option, index) => (
            <div className="option" key={"option-" + index}>
              <div className="input" key={"input-" + index}>
                <input
                  id={"scq" + questionIndex + index}
                  className={
                    option.correct == null
                      ? ""
                      : option.correct
                        ? "correct"
                        : "incorrect"
                  }
                  type="radio"
                  name={"answer" + this.props.index}
                  value={index}
                  onClick={this.handleRadioChange}
                  checked={option.selected}
                  tabIndex={-1}
                  disabled={
                    (this.props.attempts > 0 ||
                      this.props.attempts == "unlimited") &&
                    (this.props.correct == false ||
                      this.props.correct == null ||
                      this.props.attempts == "unlimited")
                      ? false
                      : true
                  }
                />
                <label
                  onKeyDown={(e) => {
                    if (e.keyCode === 13 || e.keyCode === 32)
                      this.handleRadioChangeKey(e);
                  }}
                  role="presentation"
                  htmlFor={"scq" + questionIndex + index}
                  className="response"
                  aria-label={
                    (option.selected ? "selected, " : "") +
                    (option.correct !== null
                      ? option.correct === true
                        ? "correct, "
                        : "incorrect, "
                      : "") +
                    this.props.id +
                    String.fromCharCode(97 + index) +
                    ", " +
                    option.label
                  }
                >
                  <span className="checkmark" aria-hidden={true}>
                    {String.fromCharCode(97 + index).toUpperCase()}
                  </span>
                  <FormattedMessage
                    id={option.label}
                    defaultMessage={option.label}
                    description=""
                  />
                </label>
                {this.props.options[index].image ? (
                  <img
                    className="predictionImage"
                    alt="Option"
                    src={this.props.options[index].image}
                  />
                ) : null}
              </div>
              <div
                className={
                  "feedback " +
                  (option.correct == null
                    ? ""
                    : option.correct
                      ? "correct"
                      : "incorrect")
                }
                key={index}
                style={{
                  display: option.correct === null ? "none" : "initial",
                }}
              >
                <div>
                  <p>
                    {option.feedback ? (
                      <FormattedMessage
                        id={option.feedback}
                        defaultMessage={option.feedback}
                        description=""
                      />
                    ) : (
                      ""
                    )}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="question-footer">
          <p>
            {this.props.intl.formatMessage(
              {
                id: "Attempts left: {count}",
                defaultMessage: "Attempts left: {count}",
                description: "",
              },
              {
                count: this.props.attempts,
              }
            )}
          </p>
          <button
            onClick={this.validatePSCQ}
            disabled={
              (this.props.attempts > 0 || this.props.attempts == "unlimited") &&
              !this.props.complete &&
              this.props.selected + 1
                ? false
                : true
            }
          >
            <FormattedMessage
              id="Submit answer"
              defaultMessage="Submit answer"
              description=""
            />
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const entry = state.cscq[ownProps.id];

  if (!entry) {
    return ownProps;
  }

  const disabledList = entry.disabled || [];
  const complete = disabledList.includes(ownProps.answer);

  const attemptsLeft =
    ownProps.attempts === "Unlimited"
      ? ownProps.attempts
      : ownProps.attempts - disabledList.length;

  const updatedOptions = ownProps.options.map((option, index) => {
    if (disabledList.includes(index)) {
      return {
        ...option,
        selected: false,
        correct: index === ownProps.answer ? true : false,
        disabled: true,
      };
    } else if (index === entry.selected && !complete) {
      return {
        ...option,
        selected: true,
      };
    }
    // Return the option unchanged if none of the above conditions are met.
    return option;
  });

  return {
    ...ownProps,
    options: updatedOptions,
    complete: complete,
    selected: entry.selected,
    attempts: attemptsLeft,
  };
};

export default connect(mapStateToProps, {
  cscqSelectOption,
  cscqSubmit,
})(injectIntl(PredictionsChoiceQuestion));
